<template>
  <div :style="colorTheme">
    <Component
      :is="`blueprint-${entry.blueprint?.replaceAll('_', '-')}`"
      v-if="entry"
      :page="entry"
    />
    <!--  -->
  </div>
</template>

<script setup lang="ts">
import type { PageQuery } from '#gql'

const { t } = useI18n()

const emit = defineEmits<{
  'update:entry': [entry: PageQuery['entry']]
}>()

const entry = await useInjectableEntry()
emit('update:entry', entry.value)

const colorTheme = useGetColorThemeStyles(entry)

// META TAGS
useSeotamicCustom(entry)

useHead({
  bodyAttrs: {
    class: useIsInLivePreview() ? 'live-preview-active' : '',
  },
  title: entry.value?.seotamic_meta?.title || `${entry.value?.title} - ${t('gemini_title')}`,
})
</script>
